// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"gV","product":"hV","products":"iV","tooltipWrapper":"jV","tooltip":"kV","title":"lV"};